// Sem caixa e sem acento, como a busca do backend (CONVERT ... utf8mb4_unicode_ci).
// Normaliza caractere a caractere para manter o índice no texto original.
const semAcento = (c) => c.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

// Recorta o texto em volta da 1ª ocorrência do termo e devolve pedaços
// [{ texto, destaque }] para o painel de busca pintar o que casou.
export const trechoComDestaque = (corpo, termo, antes = 40, depois = 110) => {
  const texto = String(corpo || "").replace(/\s+/g, " ").trim();
  const chars = [...texto];
  let norm = "";
  const origem = []; // posição em `chars` de cada caractere de `norm`
  chars.forEach((c, i) => {
    const n = semAcento(c);
    for (let k = 0; k < n.length; k++) origem.push(i);
    norm += n;
  });
  const alvo = [...String(termo || "").trim()].map(semAcento).join("");

  const achou = alvo ? norm.indexOf(alvo) : -1;
  if (achou < 0) return [{ texto: chars.slice(0, antes + depois).join(""), destaque: false }];

  const ini = origem[achou];
  const fim = origem[achou + alvo.length - 1] + 1;
  const de = Math.max(0, ini - antes);
  const ate = Math.min(chars.length, fim + depois);
  const pedaco = (a, b) => chars.slice(a, b).join("");

  return [
    { texto: (de > 0 ? "…" : "") + pedaco(de, ini), destaque: false },
    { texto: pedaco(ini, fim), destaque: true },
    { texto: pedaco(fim, ate) + (ate < chars.length ? "…" : ""), destaque: false },
  ];
};
